import React from 'react';
import { graphql } from 'gatsby';
import GridSection from 'design-system/src/components/organisms/GridSection';

import { getImage } from '../../utils/media';

const getSolutionImage = (solution: any) => {
    if (solution?.media) {
        return getImage(solution.media);
    }

    if (solution?.cta) {
        return getImage(solution.cta?.link?.seo?.image);
    }

    return null;
};

export default function GridNavigation1Section({
    items,
    filters,
    ...props
}: any) {
    return (
        <GridSection
            {...props}
            variant="grid-navigation-1"
            items={
                items?.length > 0 &&
                items.map((item: any) => ({
                    ...item,
                    media: getSolutionImage(item),
                }))
            }
            filters={
                filters?.length > 0 &&
                filters.map((filter: any) => ({
                    ...filter,
                    items:
                        (filter.items?.length > 0 &&
                            filter.items.map((item: any) => ({
                                ...item,
                                media: getSolutionImage(item),
                            }))) ??
                        [],
                }))
            }
        />
    );
}

export const query = graphql`
    fragment DatoCmsSolution on DatoCmsSolution {
        title
        text: description
        media: image {
            ...SourceMedia
            gatsbyImageData(width: 1436, imgixParams: { w: "1436" })
        }
        cta {
            ...Button
            link {
                ... on DatoCmsPage {
                    seo {
                        image {
                            gatsbyImageData(
                                width: 1436
                                imgixParams: { w: "1436" }
                            )
                        }
                    }
                }
                ... on DatoCmsGlossaryTerm {
                    seo {
                        image {
                            gatsbyImageData(
                                width: 1436
                                imgixParams: { w: "1436" }
                            )
                        }
                    }
                }
                ... on DatoCmsBlogPost {
                    seo {
                        image {
                            gatsbyImageData(
                                width: 1436
                                imgixParams: { w: "1436" }
                            )
                        }
                    }
                }
            }
        }
    }
    fragment DatoCmsFilterBlock on DatoCmsFilterBlock {
        name
        items {
            ...DatoCmsSolution
        }
    }
    fragment DatoCmsGridNavigation1Section on DatoCmsGridNavigation1Section {
        title
        titleTag
        description
        filters {
            ...DatoCmsFilterBlock
        }
        items {
            ...DatoCmsSolution
        }
    }
`;
